<app-header *ngIf="!isCustomer" (companyFromHeader)="onCompanyChangeInHeader($event)" [companyId]="companyId"></app-header>
<app-header-customer *ngIf="isCustomer"></app-header-customer>
<router-outlet></router-outlet>




<!-- <div class="main-outer documentcabinet-page">
    <div class="document-cabinets-wrapper">
        <div class="container">
            <div class="page-wrapper" [ngClass]="Menustatus ? 'show' : ''">
                <div class="doc-cabinet-menu-outer">
                    <app-configuration-menu></app-configuration-menu>
                </div>
                <div class="doc-cabinets-right">
                    <router-outlet></router-outlet>
                </div>                
            </div>
        </div>
    </div>
</div> -->
